import React, { FC, useState } from "react";
import { Rect } from "react-konva";
import { DEFAULT_STROKE_WIDTH } from "../../../../../../../core/common_constants";
import { toDrawUnit } from "../../../../../../../core/common_functions";
import { NullableString } from "../../../../../../../core/common_types";
import { getStrokeColor } from "../draw_utils";

export const Tubolare: FC<{x: number, y: number, length: number, width: number, rotation: number, color: HTMLImageElement|undefined, colorCode?: NullableString}> = ({x, y, length, width, rotation, color, colorCode}) => {

    return (
        <Rect
            x={x}
            y={y}
            width={toDrawUnit(width)}
            height={length}
            stroke={getStrokeColor(colorCode)}
            strokeWidth={0.5}
            fillPatternImage={color}
            rotation={rotation}
        />
    );
}